import { countryFlagClass, jurisdictionFlagClass } from '@1financial/shared';
import { clsx } from 'clsx';

interface FlagProps {
  /** ISO 3166-1 alpha-2 country code (e.g. "GB", "AE") */
  country?: string | null;
  /** 1Financial jurisdiction code (e.g. "UAE", "UK") */
  jurisdiction?: string | null;
  /** Tailwind className passthrough */
  className?: string;
}

/**
 * Renders the flag for a country OR jurisdiction.
 *
 * Single source of truth — `countryFlagClass()` and `jurisdictionFlagClass()`
 * in @1financial/shared return the `fi fi-XX` class string. Always use this
 * component, never hand-write flag class strings.
 */
export function Flag({ country, jurisdiction, className }: FlagProps) {
  const flagClass = country
    ? countryFlagClass(country)
    : jurisdiction
    ? jurisdictionFlagClass(jurisdiction)
    : 'fi fi-xx';

  return (
    <span
      className={clsx(flagClass, 'inline-block rounded-sm', className)}
      aria-hidden="true"
    />
  );
}